/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import FadeIn from "../../common/FadeIn";
import StatusBlock from "../../common/StatusBlock";
//Bootstrap
import { Form, Col, Row, Button } from "react-bootstrap";
//Analytics
import TagManager from "react-gtm-module";
//Images and Icons
import { MdSave, MdAddCircle, MdOutlineCancel } from "react-icons/md";

const AddParticipant = (props) => {
  const customerDefaultAddress = `${props.customer.Street_Address}, ${props.customer.City}, ${props.customer.Postcode}`;
  const [First_Name, setFirst_Name] = useState("");
  const [Last_Name, setLast_Name] = useState("");
  const [Address, setAddress] = useState(customerDefaultAddress);
  const [Date_Of_Birth, setDate_Of_Birth] = useState("");
  const [Emergency_Contact_1_Name, setEmergency_Contact_1_Name] = useState("");
  const [Emergency_Contact_1_Contact_Number, setEmergency_Contact_1_Contact_Number] = useState("");
  const [Emergency_Contact_2_Name, setEmergency_Contact_2_Name] = useState("");
  const [Emergency_Contact_2_Contact_Number, setEmergency_Contact_2_Contact_Number] = useState("");
  const [Special_Requirements, setSpecial_Requirements] = useState("");
  const [addConditionsToggle, setAddConditionsToggle] = useState(false);

  const currentKey = props.updateKey;

  const capitalize = (string) => {
    return string.charAt(0, 1).toUpperCase() + string.slice(1, string.length);
  };

  const createParticipant = async (e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const data = {
      First_Name: First_Name.trim(),
      Last_Name: Last_Name.trim(),
      Address: Address.trim(),
      Date_Of_Birth: Date_Of_Birth,
      Emergency_Contact_1_Name: Emergency_Contact_1_Name.trim(),
      Emergency_Contact_1_Contact_Number: Emergency_Contact_1_Contact_Number.trim(),
      Emergency_Contact_2_Name: Emergency_Contact_2_Name.trim(),
      Emergency_Contact_2_Contact_Number: Emergency_Contact_2_Contact_Number.trim(),
      Special_Requirements: Special_Requirements.trim(),
    };

    const createParticipantRequest = await axios.post(
      `/api/customer/customer_general/customer_participant_add`,
      data,
      {
        withCredentials: true,
      }
    );
    if (createParticipantRequest.status === 200) {
      TagManager.dataLayer({
        dataLayer: {
          event: "addedInitialParticipant",
        },
      });
      if (props.isDashboard) {
        props.setViewMode("view");
      }
      props.setSubmitClicked(false);
      return props.setUpdateKey(currentKey + 1);
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was an error - please contact support if it");
    }
  };

  return (
    <FadeIn delay={250} duration={450}>
      <Form className='shadow p-4 mx-auto' onSubmit={createParticipant}>
        <p>
          Participants are the people who will actually be taking a class, it may be your child,
          you, or someone else you are responsible for. We need information about them before you
          can subscribe them to our sessions.{" "}
          <strong>
            If you are attending with a child (adult and child classes), please enter the
            child&apos;s details here, not yours.
          </strong>
        </p>
        <hr />
        <Row>
          <Col sm='12' lg='4'>
            <Form.Group controlId='FirstNamesForm'>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type='text'
                maxLength='256'
                value={First_Name}
                onChange={(e) => setFirst_Name(capitalize(e.target.value))}
                required
                className='border'
              />
            </Form.Group>
          </Col>
          <Col sm='12' lg='4'>
            <Form.Group controlId='LastNamesForm'>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type='text'
                maxLength='256'
                value={Last_Name}
                onChange={(e) => setLast_Name(capitalize(e.target.value))}
                required
                className='border'
              />
            </Form.Group>
          </Col>
          <Col sm='12' lg='4'>
            <Form.Group controlId='DateOfBirth'>
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type='date'
                value={Date_Of_Birth}
                onChange={(e) => setDate_Of_Birth(e.target.value)}
                required
                className='border'
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col sm='12' lg='12'>
            <Form.Group controlId='AdressForm'>
              <Form.Label>Full Address</Form.Label>
              <Form.Control
                type='text'
                maxLength='256'
                value={Address}
                onChange={(e) => setAddress(e.target.value)}
                required
                className='border'
              />
            </Form.Group>
          </Col>
        </Row>
        <hr />
        <h4 className='mt-3'>Additional Info</h4>
        <p>
          You sometimes want us to know additional information about a participant to help facilitate our classes or keep them safe. Use this box to add additional info, if any.
        </p>
        {addConditionsToggle ? (
          <Button
            type='button'
            variant='danger'
            size='sm'
            onClick={(e) => setAddConditionsToggle(false, e)}
          >
            Cancel <MdOutlineCancel />
          </Button>
        ) : (
          <Button
            type='button'
            variant='warning'
            size='sm'
            onClick={(e) => setAddConditionsToggle(true, e)}
          >
            Add <MdAddCircle />
          </Button>
        )}
        {addConditionsToggle && (
          <Row>
            <Col sm='12'>
              <Form.Group controlId='SpecialRequirements'>
                <Form.Label>Please give details</Form.Label>
                <Form.Control
                  as='textarea'
                  type='text'
                  maxLength='256'
                  value={Special_Requirements}
                  onChange={(e) => setSpecial_Requirements(e.target.value)}
                  className='border'
                />
              </Form.Group>
            </Col>
          </Row>
        )}
        <hr />
        <h4 className='mt-3'>We need you to specify two emergency contacts</h4>
        <p>
          We aim to make sure you or someone you trust can be contacted in the extremely unlikely
          event of an emergency.
        </p>
        <Row>
          <Col sm='12' lg='6'>
            <Form.Group controlId='EmergencyContactName1'>
              <Form.Label>Emergency Contact 1: Name</Form.Label>
              <Form.Control
                type='text'
                maxLength='256'
                value={Emergency_Contact_1_Name}
                onChange={(e) => setEmergency_Contact_1_Name(e.target.value)}
                required
                className='border'
              />
            </Form.Group>
          </Col>

          <Col sm='12' lg='6'>
            <Form.Group controlId='EmergencyContactPhone1'>
              <Form.Label>Emergency Contact 1: Phone Number</Form.Label>
              <Form.Control
                type='tel'
                pattern='^[0-9 ]{1,15}$'
                value={Emergency_Contact_1_Contact_Number}
                onChange={(e) => setEmergency_Contact_1_Contact_Number(e.target.value)}
                required
                className='border'
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col sm='12' lg='6'>
            <Form.Group controlId='EmergencyContactName2'>
              <Form.Label>Emergency Contact 2: Name</Form.Label>
              <Form.Control
                type='text'
                maxLength='256'
                value={Emergency_Contact_2_Name}
                onChange={(e) => setEmergency_Contact_2_Name(e.target.value)}
                required
                className='border'
              />
            </Form.Group>
          </Col>

          <Col sm='12' lg='6'>
            <Form.Group controlId='EmergencyContactPhone2'>
              <Form.Label>Emergency Contact 2: Phone Number</Form.Label>
              <Form.Control
                type='tel'
                pattern='^[0-9 ]{1,15}$'
                value={Emergency_Contact_2_Contact_Number}
                onChange={(e) => setEmergency_Contact_2_Contact_Number(e.target.value)}
                required
                className='border'
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className='mt-4'>
          <Col sm='12'>
            {props.submitClicked || props.errorMessage !== "" ? (
              <Button
                variant='success'
                className='w-100 mt-2 mb-2 text-center '
                type='button'
                disabled
              >
                Processing...
              </Button>
            ) : (
              <Button variant='primary' className='w-100 mt-2 mb-2 text-center ' type='submit'>
                Save <MdSave />
              </Button>
            )}
            <div className='mt-2 mb-2'>
              <StatusBlock
                errorMessage={props.errorMessage}
                successMessage={props.successMessage}
                dismissMessages={props.dismissMessages}
              />
            </div>
          </Col>
        </Row>
      </Form>
    </FadeIn>
  );
};

export default AddParticipant;
